export enum StatusEnum {
  PASSIVE = 0,
  ACTIVE = 1,
  DELETED = 2,

}
